// extracted by mini-css-extract-plugin
module.exports = {"root":"MarkdownContent_root__11Dk2"};